<template>
  <div>
    <div class="json-data-info-box">
      <div>
        <BaseIcon name="infofilledv2sm" height="1.5rem" width="1.5rem" />
      </div>
      <div class="json-data-info-text">
        {{ $t('notification.defaultJsonDisplayInfo') }}
      </div>
    </div>
    <div class="data-type-field">
      <div class="data-header-text">
Content-Type: application/json
</div>
      <RexCodeEditor
        :value="editorValue"
        @input="(val) => $emit('onTextChange', val)"
        :lang="lang"
        :styleObj="{ height: '23rem', width: '52rem' }"
        :autocompletions="autocompletions"
      />
    </div>
  </div>
</template>

<script>
import RexCodeEditor from '@/rex-components/rex-code-editor.vue';
import { addChannelVariablesList } from '@/components/Notification/notification.type';
import { json } from '@codemirror/lang-json';

export default {
  components: { RexCodeEditor },
  props: {
    editorValue: {
      type: String,
      required: true,
    },
  },
  setup() {
    const lang = json();

    return {
      lang,
      autocompletions: addChannelVariablesList,
    };
  },
};
</script>

<style lang="scss" scoped>
.data-type-field {
  background-color: rgb(26, 26, 26);
  border-radius: 0.5rem;
  padding-bottom: 0.875rem;
  margin-bottom: 0.5rem;
}
.data-header-text {
  margin-left: 3.438rem;
  padding: 0.25rem 0rem;
  color: $table-header-text-grey;
  font-size: 0.875rem;
}
.json-data-info-box {
  @include flex-center-vert;
  margin-bottom: 0.5rem;
}
.json-data-info-text {
  color: $color-brand-accent;
  font-size: 1rem;
  margin-left: 0.5rem;
}
</style>
